<template>
  <div>
    <b-sidebar
      id="sidebar-menu"
      aria-labelledby="sidebar-menu-title"
      no-header
      shadow
      bg-variant="primary"
      text-variant="white"
      backdrop
      backdrop-variant="dark"
      :z-index="1020"
      :no-close-on-route-change="false"
      :no-close-on-esc="false"
      :no-close-on-backdrop="false"
    >
      <template #footer="{ hide }">
        <div class="sidebar-footer d-flex text-light align-items-center px-3 py-2">
          <div class="version-info">
            <div class="version-text"><b-icon icon="hash" class="version-icon"></b-icon>{{ versionInfo.version }}</div>
            <div class="release-info"><i class="fas fa-rocket release-icon"></i>{{ versionInfo.releaseDate }}</div>

            <!-- <i class="fas fa-rocket"></i> -->
          </div>
          <b-button
            variant="outline-secondary"
            no-border
            size="sm"
            @click="
              hide()
              closeAllMenus()
            "
            >✕</b-button
          >
        </div>
      </template>

      <template #default="{ hide }">
        <div class="sidebar-container p-3">
          <div class="sidebar-header d-flex align-items-center flex-column">
            <h4 id="sidebar-menu">Lojas Express</h4>
            <div class="menu"></div>
          </div>

          <b-nav vertical>
            <b-nav-item
              to="/home"
              @click="
                hide()
                clearLocalStorageSavedPages()
              "
            >
              <b-icon icon="house" class="menu-icon"></b-icon>
              Início
            </b-nav-item>

            <b-nav-item
              v-if="hasUsersListPermission || hasUserManagerPermission"
              @click="toggleUsersMenu()"
              class="menu1-item"
              :class="{ 'rotate-down': isToggleUsers }"
            >
              <i class="fas fa-id-card-alt menu-icon"></i>
              Usuários
            </b-nav-item>

            <b-collapse id="Users" v-model="isToggleUsers">
              <b-nav-item
                v-if="hasUsersListPermission"
                to="/users-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>

              <b-nav-item
                v-if="hasUserManagerPermission"
                to="/users-manager"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="plus-square-fill" class="menu-icon"></b-icon>
                Cadastro
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasProductsListPermission"
              @click="toggleStock()"
              v-model="isToggleStock"
              class="menu1-item"
              :class="{ 'rotate-down': isToggleStock }"
            >
              <i class="fas fa-pallet menu-icon"></i>
              Estoque
            </b-nav-item>

            <b-collapse id="StockProducts" v-model="isToggleStock">
              <b-nav-item
                v-if="hasProductsListPermission"
                @click="toggleStockProducts()"
                v-model="isToggleStockProducts"
                class="menu2-item"
                :class="{ 'rotate-down': isToggleStockProducts }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="far fa-image menu-icon"></i>
                Produtos
              </b-nav-item>
            </b-collapse>

            <b-collapse id="StockProducts-Search" v-model="isToggleStockProducts">
              <b-nav-item
                v-if="hasProductsListPermission"
                to="/products-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>
            </b-collapse>

            <b-collapse id="StockAdjustment" v-model="isToggleStock">
              <b-nav-item
                v-if="hasStockAdjustmentDocumentsPermission || hasDetailsItemsDocumentsPermission || hasStockAdjustmentItemsDocumentsPermission"
                @click="toggleStockAdjustment()"
                v-model="isToggleStockAdjustment"
                class="menu2-item"
                :class="{ 'rotate-down': isToggleStockAdjustment }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="far fa-image menu-icon"></i>
                Ajustes
              </b-nav-item>
            </b-collapse>

            <b-collapse id="StockAdjustmentSearch" v-model="isToggleStockAdjustment">
              <b-nav-item
                v-if="hasStockAdjustmentDocumentsPermission"
                to="/stock-adjustment-documents"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta Documentos
              </b-nav-item>

              <b-nav-item
                v-if="hasDetailsItemsDocumentsPermission"
                to="/stock-adjustment-details-items"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta Itens Detalhados
              </b-nav-item>

              <b-nav-item
                v-if="hasStockAdjustmentItemsDocumentsPermission"
                to="/stock-adjustment-items"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta Itens Agrupados
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasCustomerListPermission || hasCustomersExceptionsListPermission"
              @click="toggleCustomersMenu()"
              v-model="isToggleCustomers"
              class="menu1-item"
              :class="{ 'rotate-down': isToggleCustomers }"
            >
              <i class="fas fa-users menu-icon"></i>
              Clientes
            </b-nav-item>

            <b-collapse id="Customers" v-model="isToggleCustomers">
              <b-nav-item
                v-if="hasCustomerListPermission"
                to="customer-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>
            </b-collapse>

            <b-collapse id="CustomersExceptionsList" v-model="isToggleCustomers">
              <b-nav-item
                v-if="hasCustomersExceptionsListPermission"
                to="customers-exceptions-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-user-lock menu-icon"></i>
                Consulta Lista de Exceções
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasSalesListPermission || hasOrderItemsListPermission || hasOrderPaymentsListPermission || hasOrderPaymentsDetailedListPermission"
              @click="toggleOrdersMenu()"
              v-model="isToggleOrders"
              class="menu1-item"
              :class="{ 'rotate-down': isToggleOrders }"
            >
              <i class="fas fa-clipboard-list menu-icon"></i>
              Vendas
            </b-nav-item>

            <b-collapse id="Orders" v-model="isToggleOrders">
              <b-nav-item
                v-if="hasSalesListPermission"
                to="/orders-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>

              <b-nav-item
                v-if="hasOrderItemsListPermission"
                to="/order-items-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-list menu-icon"></i>
                Itens Vendidos
              </b-nav-item>

              <b-nav-item
                v-if="hasOrderPaymentsListPermission || hasOrderPaymentsDetailedListPermission"
                @click="toggleOrderPayments()"
                v-model="isToggleOrderPayments"
                class="menu3-5-item"
                :class="{ 'rotate-down': isToggleOrderPayments }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="fa fa-receipt menu-icon"></i>
                Recebimentos
              </b-nav-item>

              <b-collapse id="OrderPayments" v-model="isToggleOrderPayments">
                <b-nav-item
                  v-if="hasOrderPaymentsListPermission"
                  to="/order-payments"
                  @click="
                    hide()
                    clearLocalStorageSavedPages()
                  "
                  class="sidebar-sublink-2"
                >
                  <i class="fa fa-wallet menu-icon"></i>
                  Agrupado
                </b-nav-item>

                <b-nav-item
                  v-if="hasOrderPaymentsDetailedListPermission"
                  to="/order-payments-detailed"
                  @click="
                    hide()
                    clearLocalStorageSavedPages()
                  "
                  class="sidebar-sublink-2"
                >
                  <i class="fa fa-wallet menu-icon"></i>
                  Detalhado
                </b-nav-item>
              </b-collapse>
            </b-collapse>

            <b-nav-item
              v-if="hasBannerAppListPermission || hasBannerAppManagerPermission || hasBannersTotemListPermission || hasBannersManagerPermission"
              @click="toggleBanners()"
              v-model="isToggleBanners"
              class="menu1-item"
              :class="{ 'rotate-down': isToggleBanners }"
            >
              <i class="far fa-image menu-icon"></i>
              Banners
            </b-nav-item>

            <b-collapse id="BannerApp" v-model="isToggleBanners">
              <b-nav-item
                v-if="hasBannerAppListPermission || hasBannerAppManagerPermission"
                @click="toggleBannerAplicativo()"
                v-model="isToggleBannerApp"
                class="menu2-item"
                :class="{ 'rotate-down': isToggleBannerApp }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="far fa-image menu-icon"></i>
                Aplicativo
              </b-nav-item>
            </b-collapse>

            <b-collapse id="BannerAppMenu" v-model="isToggleBannerApp">
              <b-nav-item
                v-if="hasBannerAppListPermission"
                to="/banners-app-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>

              <b-nav-item
                v-if="hasBannerAppManagerPermission"
                to="/banners-app-manager"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="plus-square-fill" class="menu-icon"></b-icon>
                Cadastro
              </b-nav-item>
            </b-collapse>

            <b-collapse id="BannerTotem" v-model="isToggleBanners">
              <b-nav-item
                v-if="hasBannersTotemListPermission || hasBannersManagerPermission"
                @click="toggleBannerTotem()"
                v-model="isToggleBannerTotem"
                class="menu2-item"
                :class="{ 'rotate-down': isToggleBannerTotem }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="far fa-image menu-icon"></i>
                Totem
              </b-nav-item>
            </b-collapse>

            <b-collapse id="BannerTotemMenu" v-model="isToggleBannerTotem">
              <b-nav-item
                v-if="hasBannersTotemListPermission"
                to="/banners-totem-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>

              <b-nav-item
                v-if="hasBannersManagerPermission"
                to="/banners-manager"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="plus-square-fill" class="menu-icon"></b-icon>
                Cadastro
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasBotSpeechsPermission || hasBotBoundedPermission || hasBotPermission || hasBotBoundPermission"
              @click="toggleBot()"
              v-model="isToggleBot"
              class="menu3-5-item"
              :class="{ 'rotate-down': isToggleBot }"
            >
              <i class="fas fa-robot menu-icon"></i>
              Falas Dispositivos
            </b-nav-item>

            <b-collapse id="Bot" v-model="isToggleBot">
              <b-nav-item
                v-if="hasBotPermission"
                to="/bot"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-plus-circle menu-icon"></i>
                Cadastrar Fala
              </b-nav-item>

              <b-nav-item
                v-if="hasBotSpeechsPermission"
                to="/bot-speechs"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-search menu-icon"></i>
                Consultar Fala
              </b-nav-item>

              <b-nav-item
                v-if="hasBotBoundPermission"
                to="/bot-bound"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-link menu-icon"></i>
                Vincular Fala
              </b-nav-item>

              <b-nav-item
                v-if="hasBotBoundedPermission"
                to="/bot-bounded"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-list-alt menu-icon"></i>
                Consultar Vínculos
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasDiscountCouponListPermission || hasDiscountCouponManagerPermission"
              @click="toggleDiscountCoupon()"
              v-model="isToggleDiscountCoupon"
              class="menu4-item"
              :class="{ 'rotate-down': isToggleDiscountCoupon }"
            >
              <i class="fas fa-tag menu-icon"></i>
              Cupons de Desconto
            </b-nav-item>

            <b-collapse id="DiscountCoupon" v-model="isToggleDiscountCoupon">
              <b-nav-item
                v-if="hasDiscountCouponListPermission"
                to="discount-coupon-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>

              <b-nav-item
                v-if="hasDiscountCouponManagerPermission"
                to="discount-coupon-manager"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="plus-square-fill" class="menu-icon"></b-icon>
                Cadastro
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasPushCampaignListPermission || hasPushCampaignManagerPermission"
              @click="togglePushCampaign()"
              v-model="isTogglePushCampaign"
              class="menu3-5-item"
              :class="{ 'rotate-down': isTogglePushCampaign }"
            >
              <i class="fas fa-paper-plane menu-icon"></i>
              Campanha Push
            </b-nav-item>

            <b-collapse id="PushCampaign" v-model="isTogglePushCampaign">
              <b-nav-item
                v-if="hasPushCampaignListPermission"
                to="push-campaign-list"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>

              <b-nav-item
                v-if="hasPushCampaignManagerPermission"
                to="push-campaign-manager"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="plus-square-fill" class="menu-icon"></b-icon>
                Cadastro
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasPromotionsListPermission"
              @click="togglePromotions()"
              v-model="isTogglePromotions"
              class="menu1-5-item"
              :class="{ 'rotate-down': isTogglePromotions }"
            >
              <i class="fas fa-percentage menu-icon"></i>
              Promoções
            </b-nav-item>

            <b-collapse id="Promotions" v-model="isTogglePromotions">
              <b-nav-item
                v-if="hasPromotionsListPermission"
                to="promotions"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <b-icon icon="table" class="menu-icon"></b-icon>
                Consulta
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasDeviceHistoryPermission || hasEventsHistoryPermission"
              @click="toggleControl()"
              v-model="isToggleControl"
              class="menu1-item"
              :class="{ 'rotate-down': isToggleControl }"
            >
              <i class="fas fa-history menu-icon"></i>
              Históricos
            </b-nav-item>

            <b-collapse id="Control" v-model="isToggleControl">
              <b-nav-item
                v-if="hasDeviceHistoryPermission"
                to="device-history"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-history menu-icon"></i>
                Histórico Dispositivos
              </b-nav-item>
            </b-collapse>

            <b-collapse id="Events" v-model="isToggleControl">
              <b-nav-item
                v-if="hasEventsHistoryPermission"
                to="events-history"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink"
              >
                <i class="fas fa-history menu-icon"></i>
                Histórico Eventos
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasGatewayDocumentPermission || hasCustomersRecognitionGatewayPermission || hasValidateAppCodePermission"
              @click="toggleManagement()"
              v-model="isToggleManagement"
              class="menu1-5-item"
              :class="{ 'rotate-down': isToggleManagement }"
            >
              <i class="fas fa-cog menu-icon"></i>
              Gerencial
            </b-nav-item>

            <b-collapse id="ManagementGateways" v-model="isToggleManagement">
              <b-nav-item
                v-if="hasGatewayDocumentPermission || hasCustomersRecognitionGatewayPermission || hasValidationRegisterGatewayPermission"
                @click="toggleManagmentGateways()"
                v-model="isToggleManagmentGateways"
                class="menu2-item"
                :class="{ 'rotate-down': isToggleManagmentGateways }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="far fa-address-book menu-icon"></i>
                Gateways
              </b-nav-item>
            </b-collapse>

            <b-collapse id="ManagementGatewaysDocuments" v-model="isToggleManagmentGateways">
              <b-nav-item
                v-if="hasGatewayDocumentPermission"
                to="/gateway-documents"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <i class="far fa-file-alt menu-icon"></i>
                Documentos
              </b-nav-item>
            </b-collapse>

            <b-collapse id="ManagementGatewaysRecognition" v-model="isToggleManagmentGateways">
              <b-nav-item
                v-if="hasCustomersRecognitionGatewayPermission"
                to="/gateway-recognition"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <i class="far fa-grin-alt menu-icon"></i>
                Reconhecimento Facial
              </b-nav-item>
            </b-collapse>

            <b-collapse id="ManagementGatewaysValidationRegister" v-model="isToggleManagmentGateways">
              <b-nav-item
                v-if="hasValidationRegisterGatewayPermission"
                to="/gateway-validation-register"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <i class="fas fa-user-check menu-icon"></i>
                Validação de Registro
              </b-nav-item>
            </b-collapse>

            <b-collapse id="ManagementGateways" v-model="isToggleManagement">
              <b-nav-item
                v-if="hasValidateAppCodePermission"
                @click="toggleManagmentCodes()"
                v-model="isToggleManagmentCodes"
                class="menu2-item"
                :class="{ 'rotate-down': isToggleManagmentCodes }"
                style="color: white !important; margin-left: 1.5rem"
              >
                <i class="material-symbols-outlined menu-icon"> 123 </i>
                Códigos
              </b-nav-item>
            </b-collapse>

            <b-collapse id="ManagementGatewaysDocuments" v-model="isToggleManagmentCodes">
              <b-nav-item
                v-if="hasValidateAppCodePermission"
                to="/validate-app-code"
                @click="
                  hide()
                  clearLocalStorageSavedPages()
                "
                class="sidebar-sublink-2"
              >
                <b-icon icon="check2-all" class="menu-icon"></b-icon>
                Ativação Aplicativo
              </b-nav-item>
            </b-collapse>

            <b-nav-item
              v-if="hasMonitoringPermission"
              to="/monitoring-pos"
              @click="
                hide()
                clearLocalStorageSavedPages()
              "
            >
              <b-icon icon="display" class="menu-icon"></b-icon>
              Monitoramento
            </b-nav-item>

            <b-nav-item
              v-if="hasDevicesListPermission"
              to="/devices-list"
              @click="
                hide()
                clearLocalStorageSavedPages()
              "
            >
              <b-icon icon="cpu" class="menu-icon"></b-icon>
              Dispositivos
            </b-nav-item>

            <b-nav-item
              v-if="hasApplicationsListPermission"
              to="/applications-list"
              @click="
                hide()
                clearLocalStorageSavedPages()
              "
            >
              <b-icon icon="tablet" class="menu-icon"></b-icon>
              Aplicativos
            </b-nav-item>

            <b-nav-item
              to="/login"
              @click="
                hide()
                clearLocalStorageSavedPages()
              "
            >
              <i class="fas fa-sign-out-alt menu-icon"></i>
              Sair
            </b-nav-item>
          </b-nav>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { getVersionInfo } from '@/config/version.js'

export default {
  name: 'SideBar',
  data() {
    return {
      permissions: [],
      userPermissions: [],
      typeUser: '',
      isToggleUsers: false,
      isToggleProducts: false,
      isToggleCustomers: false,
      isToggleOrders: false,
      isToggleBanners: false,
      isToggleBannerApp: false,
      isToggleBannerTotem: false,
      isToggleBot: false,
      isToggleDiscountCoupon: false,
      isTogglePushCampaign: false,
      isTogglePromotions: false,
      isToggleControl: false,
      isToggleManagement: false,
      isToggleStock: false,
      isToggleStockProducts: false,
      isToggleStockAdjustment: false,
      isToggleManagmentGateways: false,
      isToggleManagmentCodes: false,
      isToggleOrderPayments: false,
      lastMenuClicked: '',
      versionInfo: getVersionInfo()
    }
  },

  methods: {
    async getPermissions() {
      this.permissions = await JSON.parse(sessionStorage.getItem('permissions'))
      await this.mapUserPermissions(this.permissions)
    },

    async mapUserPermissions(permissions) {
      if (!Array.isArray(permissions)) {
        this.userPermissions = []
        return
      }
      const commands = permissions.filter(item => item.command).map(item => item.command)
      this.userPermissions = commands
    },

    // Método para abrir menus baseado na rota atual
    openMenusBasedOnRoute() {
      const currentRoute = this.$route.path

      // Resetar todos os menus primeiro
      this.closeAllMenus()

      // Verificar e abrir menus baseado na rota
      if (currentRoute.includes('/users-')) {
        this.isToggleUsers = true
        this.lastMenuClicked = 'Users'
      }

      if (currentRoute.includes('/products-') || currentRoute.includes('/stock-')) {
        this.isToggleStock = true
        this.lastMenuClicked = 'Stock'

        if (currentRoute.includes('/stock-adjustment')) {
          this.isToggleStockAdjustment = true
        }
      }

      if (currentRoute.includes('/customer') || currentRoute.includes('/customers-')) {
        this.isToggleCustomers = true
        this.lastMenuClicked = 'Customers'
      }

      if (currentRoute.includes('/order') || currentRoute.includes('/sales')) {
        this.isToggleOrders = true
        this.lastMenuClicked = 'Orders'

        if (currentRoute.includes('/order-payments')) {
          this.isToggleOrderPayments = true
        }
      }

      if (currentRoute.includes('/banner')) {
        this.isToggleBanners = true
        this.lastMenuClicked = 'Banners'

        if (currentRoute.includes('/banners-app')) {
          this.isToggleBannerApp = true
        } else if (currentRoute.includes('/banners-') && !currentRoute.includes('/banners-app')) {
          this.isToggleBannerTotem = true
        }
      }

      if (currentRoute.includes('/bot')) {
        this.isToggleBot = true
        this.lastMenuClicked = 'Bot'
      }

      if (currentRoute.includes('/discount-coupon')) {
        this.isToggleDiscountCoupon = true
        this.lastMenuClicked = 'DiscountCoupon'
      }

      if (currentRoute.includes('/push-campaign')) {
        this.isTogglePushCampaign = true
        this.lastMenuClicked = 'PushCampaign'
      }

      if (currentRoute.includes('/promotion')) {
        this.isTogglePromotions = true
        this.lastMenuClicked = 'Promotions'
      }

      if (currentRoute.includes('/device-history') || currentRoute.includes('/events-history')) {
        this.isToggleControl = true
        this.lastMenuClicked = 'Control'
      }

      if (currentRoute.includes('/gateway') || currentRoute.includes('/validate-app-code')) {
        this.isToggleManagement = true
        this.lastMenuClicked = 'Management'

        if (currentRoute.includes('/gateway')) {
          this.isToggleManagmentGateways = true
        } else if (currentRoute.includes('/validate-app-code')) {
          this.isToggleManagmentCodes = true
        }
      }
    },

    closeAllMenus() {
      this.isToggleUsers = false
      this.isToggleStock = false
      this.isToggleStockProducts = false
      this.isToggleStockAdjustment = false
      this.isToggleCustomers = false
      this.isToggleOrders = false
      this.isToggleBanners = false
      this.isToggleBannerApp = false
      this.isToggleBannerTotem = false
      this.isToggleBot = false
      this.isToggleDiscountCoupon = false
      this.isTogglePushCampaign = false
      this.isTogglePromotions = false
      this.isToggleControl = false
      this.isToggleManagement = false
      this.isToggleManagmentGateways = false
      this.isToggleManagmentCodes = false
      this.isToggleOrderPayments = false
    },

    toggleUsersMenu() {
      if (this.lastMenuClicked === 'Users' && this.isToggleUsers) {
        this.isToggleUsers = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Users'
        this.isToggleUsers = true
      }
    },

    toggleCustomersMenu() {
      if (this.lastMenuClicked === 'Customers' && this.isToggleCustomers) {
        this.isToggleCustomers = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Customers'
        this.isToggleCustomers = true
      }
    },

    toggleOrdersMenu() {
      if (this.lastMenuClicked === 'Orders' && this.isToggleOrders) {
        this.isToggleOrders = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Orders'
        this.isToggleOrders = true
      }
    },

    toggleStock() {
      if (this.lastMenuClicked === 'Stock' && this.isToggleStock) {
        this.isToggleStock = false
        this.isToggleStockProducts = false
        this.isToggleStockAdjustment = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Stock'
        this.isToggleStock = true
      }
    },

    toggleStockProducts() {
      this.isToggleStockProducts = !this.isToggleStockProducts

      if (this.isToggleStockAdjustment) {
        this.isToggleStockAdjustment = !this.isToggleStockAdjustment
      }
    },

    toggleStockAdjustment() {
      this.isToggleStockAdjustment = !this.isToggleStockAdjustment

      if (this.isToggleStockProducts) {
        this.isToggleStockProducts = !this.isToggleStockProducts
      }
    },

    toggleBanners() {
      if (this.lastMenuClicked === 'Banners' && this.isToggleBanners) {
        this.isToggleBanners = false
        this.isToggleBannerApp = false
        this.isToggleBannerTotem = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Banners'
        this.isToggleBanners = true
      }
    },

    toggleBannerAplicativo() {
      this.isToggleBannerApp = !this.isToggleBannerApp

      if (this.isToggleBannerTotem) {
        this.isToggleBannerTotem = !this.isToggleBannerTotem
      }
    },

    toggleBannerAppMenu() {
      this.isToggleBannerApp = !this.isToggleBannerApp
      this.isToggleBanners = !this.isToggleBanners
      this.isToggleBannerTotem = !this.isToggleBannerTotem
    },

    toggleBannerTotem() {
      this.isToggleBannerTotem = !this.isToggleBannerTotem

      if (this.isToggleBannerApp) {
        this.isToggleBannerApp = !this.isToggleBannerApp
      }
    },

    toggleOrderPayments() {
      this.isToggleOrderPayments = !this.isToggleOrderPayments
    },

    toggleBot() {
      if (this.lastMenuClicked === 'Bot' && this.isToggleBot) {
        this.isToggleBot = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Bot'
        this.isToggleBot = true
      }
    },

    toggleDiscountCoupon() {
      if (this.lastMenuClicked === 'DiscountCoupon' && this.isToggleDiscountCoupon) {
        this.isToggleDiscountCoupon = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'DiscountCoupon'
        this.isToggleDiscountCoupon = true
      }
    },

    togglePushCampaign() {
      if (this.lastMenuClicked === 'PushCampaign' && this.isTogglePushCampaign) {
        this.isTogglePushCampaign = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'PushCampaign'
        this.isTogglePushCampaign = true
      }
    },

    togglePromotions() {
      if (this.lastMenuClicked === 'Promotions' && this.isTogglePromotions) {
        this.isTogglePromotions = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Promotions'
        this.isTogglePromotions = true
      }
    },

    toggleControl() {
      if (this.lastMenuClicked === 'Control' && this.isToggleControl) {
        this.isToggleControl = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Control'
        this.isToggleControl = true
      }
    },

    toggleManagement() {
      if (this.lastMenuClicked === 'Management' && this.isToggleManagement) {
        this.isToggleManagement = false
        this.isToggleManagmentGateways = false
        this.isToggleManagmentCodes = false
        this.lastMenuClicked = ''
      } else {
        this.closeAllMenus()
        this.lastMenuClicked = 'Management'
        this.isToggleManagement = true
      }
    },

    toggleManagmentGateways() {
      this.isToggleManagmentGateways = !this.isToggleManagmentGateways
    },

    toggleManagmentCodes() {
      this.isToggleManagmentCodes = !this.isToggleManagmentCodes
    },

    async toggleAllMenu() {
      await this.getPermissions()
      // Não fechar menus aqui, deixar o openMenusBasedOnRoute fazer isso
    },

    // clearLocalStorageSavedPages() {
    //   //*** Coupon Discount ***//
    //   localStorage.removeItem('selectedOptionAppCoupon')
    //   localStorage.removeItem('selectedDateOptionCoupon')
    //   localStorage.removeItem('startDateCoupon')
    //   localStorage.removeItem('endDateCoupon')
    //   localStorage.removeItem('selectedTypeDiscountOption')
    //   localStorage.removeItem('selectedRadioCoupon')
    //   localStorage.removeItem('currentPageCoupon')
    //   localStorage.removeItem('appsId-CouponsDiscount')
    //   localStorage.removeItem('startDateCouponDiscount')
    //   localStorage.removeItem('startTimeCouponDiscount')
    //   localStorage.removeItem('titleCouponDiscount')
    //   localStorage.removeItem('descriptionCouponDiscount')
    //   localStorage.removeItem('expiry')
    //   localStorage.removeItem('expiryAtCouponDiscount')
    //   localStorage.removeItem('endTimeCouponDiscount')
    //   localStorage.removeItem('typeCouponDiscount')
    //   localStorage.removeItem('valueCouponDiscount')
    //   localStorage.removeItem('idCustomersCouponDiscount')
    //   localStorage.removeItem('push')
    //   localStorage.removeItem('isReusable')

    //   //*** Promotions ***//
    //   localStorage.removeItem('selectedOptionCompanyPromotion')
    //   localStorage.removeItem('descriptionPromotion')
    //   localStorage.removeItem('selectedRadioPromotion')
    //   localStorage.removeItem('selectedDatePromotionOption')
    //   localStorage.removeItem('startDatePromotion')
    //   localStorage.removeItem('endDatePromotion')
    //   localStorage.removeItem('currentPagePromotion')

    //   //*** Campaigns ***//
    //   localStorage.removeItem('selectedOptionDateCompany')
    //   localStorage.removeItem('startDateCompany')
    //   localStorage.removeItem('endDateCompany')
    //   localStorage.removeItem('selectedOptionFilterCompany')
    //   localStorage.removeItem('filterCompany')
    //   localStorage.removeItem('currentPageCampaignCompany')

    //   //*** Users ***/
    //   localStorage.removeItem('currentPageUsers')
    //   localStorage.removeItem('selectedOptionFilterUser')
    //   localStorage.removeItem('filterUser')
    //   localStorage.removeItem('redirectUserPermissions')

    //   //*** App Banner ***/
    //   localStorage.removeItem('selectedOptionCompanyAppBanner')

    //   //*** Totem Banner ***//
    //   localStorage.removeItem('selectedOptionCompanyTotemBanner')

    //   //*** Search Speechs ***//
    //   localStorage.removeItem('currentPageSearchSpeechs')
    //   localStorage.removeItem('selectedOptionCompanySearchSpeechs')
    //   localStorage.removeItem('selectedOptionSiteSearchSpeechs')
    //   localStorage.removeItem('selectedOptionFilterSearchSpeechs')
    //   localStorage.removeItem('filterSearchSpeechs')

    //   //*** Customer Page ***//
    //   localStorage.removeItem('selectedOptionAppCustomerPage')
    //   localStorage.removeItem('selectedOptionCustomerPage')
    //   localStorage.removeItem('customerCustomerPage')
    //   localStorage.removeItem('selectedRadioCustomerPage')
    //   localStorage.removeItem('selectedRadioCustomerBlockCustomerPage')
    //   localStorage.removeItem('selectedPageCustomerPage')

    //   //*** Site Products ***//
    //   localStorage.removeItem('companyIdProductSite')
    //   localStorage.removeItem('siteIdProductSite')
    //   localStorage.removeItem('fantasyProductSite')
    //   localStorage.removeItem('currentPageProductSite')

    //   //*** Monitoring ***/
    //   localStorage.removeItem('siteIdMonitoringSite')

    //   //*** Orders ***/
    //   localStorage.removeItem('orderId')
    //   localStorage.removeItem('companyIdOrder')
    //   localStorage.removeItem('siteIdOrder')
    //   localStorage.removeItem('filterOption')
    //   localStorage.removeItem('startDateOrder')
    //   localStorage.removeItem('endDateOrder')
    //   localStorage.removeItem('currentPageSales')
    //   localStorage.removeItem('selectedFilterOptionSales')
    //   localStorage.removeItem('selectedFilterItem')
    //   localStorage.removeItem('filter')
    // }

    clearLocalStorageSavedPages() {
      const preservedWelcome = localStorage.getItem('welcomeModalViewedVersions')
      localStorage.clear()
      if (preservedWelcome !== null) {
        localStorage.setItem('welcomeModalViewedVersions', preservedWelcome)
      }
    }
  },

  async beforeMount() {
    this.typeUser = sessionStorage.getItem('typeUser')
    await this.getPermissions()
    this.openMenusBasedOnRoute()
  },

  mounted() {
    // Escutar evento de abertura do sidebar
    this.$root.$on('bv::sidebar::shown', (event, sidebarId) => {
      if (sidebarId === 'sidebar-menu') {
        this.openMenusBasedOnRoute()
      }
    })
  },

  watch: {
    // Fechar todos os menus quando a rota mudar
    $route() {
      this.openMenusBasedOnRoute()
    }
  },

  beforeDestroy() {
    // Remover listeners para evitar memory leaks
    this.$root.$off('bv::sidebar::shown')
  },

  computed: {
    hasProductsListPermission() {
      return this.userPermissions.includes('products_list')
    },
    hasProductsSiteListPermission() {
      return this.userPermissions.includes('products_site')
    },
    hasUsersListPermission() {
      return this.userPermissions.includes('users_list')
    },
    hasUserManagerPermission() {
      return this.userPermissions.includes('users_manager')
    },
    hasBannersTotemListPermission() {
      return this.userPermissions.includes('banners_list')
    },
    hasBannersManagerPermission() {
      return this.userPermissions.includes('banners_manager')
    },
    hasBannerAppListPermission() {
      return this.userPermissions.includes('banner_app_list')
    },
    hasBannerAppManagerPermission() {
      return this.userPermissions.includes('banner_app_manager')
    },
    hasCustomerListPermission() {
      return this.userPermissions.includes('customer_list')
    },
    hasSalesListPermission() {
      return this.userPermissions.includes('sales_list')
    },
    hasMonitoringPermission() {
      return this.userPermissions.includes('monitoring')
    },
    hasBotPermission() {
      return this.userPermissions.includes('bot')
    },
    hasBotBoundPermission() {
      return this.userPermissions.includes('bot_bound')
    },
    hasBotSpeechsPermission() {
      return this.userPermissions.includes('bot_speechs')
    },
    hasBotBoundedPermission() {
      return this.userPermissions.includes('bot_bounded')
    },
    hasDiscountCouponListPermission() {
      return this.userPermissions.includes('discount_coupon_list')
    },
    hasDiscountCouponManagerPermission() {
      return this.userPermissions.includes('discount_coupon_manager')
    },
    hasPushCampaignListPermission() {
      return this.userPermissions.includes('push_campaign_list')
    },
    hasPushCampaignManagerPermission() {
      return this.userPermissions.includes('push_campaign_manager')
    },
    hasPromotionsListPermission() {
      return this.userPermissions.includes('promotions_list')
    },
    hasGatewayDocumentPermission() {
      return this.userPermissions.includes('gateway_document')
    },
    hasOrderItemsListPermission() {
      return this.userPermissions.includes('order_items_list')
    },
    hasProductsSitePermission() {
      return this.userPermissions.includes('products_site')
    },
    hasDeviceHistoryPermission() {
      return this.userPermissions.includes('device_history')
    },
    hasApplicationsListPermission() {
      return this.userPermissions.includes('applications_list')
    },
    hasEventsHistoryPermission() {
      return this.userPermissions.includes('events_history')
    },
    hasCustomersExceptionsListPermission() {
      return this.userPermissions.includes('customers_exceptions_list')
    },
    hasStockAdjustmentDocumentsPermission() {
      return this.userPermissions.includes('stock_adjustment_documents')
    },
    hasDetailsItemsDocumentsPermission() {
      return this.userPermissions.includes('details_items_documents')
    },
    hasStockAdjustmentItemsDocumentsPermission() {
      return this.userPermissions.includes('stock_adjustment_items_documents')
    },
    hasCustomersRecognitionGatewayPermission() {
      return this.userPermissions.includes('customers_recognition_gateway')
    },
    hasValidateAppCodePermission() {
      return this.userPermissions.includes('validate_app_code')
    },
    hasOrderPaymentsListPermission() {
      return this.userPermissions.includes('order_payments')
    },
    hasOrderPaymentsDetailedListPermission() {
      return this.userPermissions.includes('order_payments_detailed')
    },
    hasDevicesListPermission() {
      return this.userPermissions.includes('setup')
    },
    hasValidationRegisterGatewayPermission() {
      return this.userPermissions.includes('validation_register_gateway')
    }
  }
}
</script>
<style lang="scss" src="../assets/scss/sidebar.scss" scoped />
<style scoped>
.version-icon {
  margin-right: 0px;
}

.version-text {
  margin-left: 0px;
  font-size: 15px;
}

.release-info {
  margin-right: 0px;
  font-size: 12px;
}

.release-icon {
  margin-right: 0px;
  font-size: 12px;
}
</style>
